import Vue from 'vue';
import VueRouter from 'vue-router';
import manageModules from '@/manage-modules';
// import App from '../App';

Vue.use(VueRouter);


const routes = [
  // {
  //   path: '/',
  //   name: 'App',
  //   component: App,
  // },
];
// const routes = [];
Object.keys(manageModules).forEach((moduleName) => {
  const pageModule = manageModules[moduleName];
  if (pageModule.path && pageModule.component) {
    routes.push({
      path: `/${pageModule.path}`,
      name: `${pageModule.displayNameKey}.module_name`,
      component: pageModule.component,
    });
  }

  if (!pageModule.pages) {
    return;
  }
  pageModule.pages.forEach((page) => {
    routes.push({
      path: `/manage/${page.path}`,
      component: page.component,
      children: page.childrenPath || [],
    });
  });
});

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (!token) {
    window.location = '/login.html?invalid=1';
  } else {
    const invalidAuditRoutes = [
      '/manage/audit-system',
      '/manage/audit-enterprise',
    ];
    if (invalidAuditRoutes.includes(to.path)) {
      next('/manage/audit-robot');
    } else {
      next();
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js